// extracted by mini-css-extract-plugin
export default {"outer":"Video_outer__SSFi1","inner":"Video_inner__kwrJx"};